import React from 'react';
import { RowsPhotoAlbum } from "react-photo-album";
import "react-photo-album/rows.css";
// import '../styles/Album.css';

const photos1 = [
    {
        "src": "./album-pictures/1.jpg",
        "width": 2304,
        "alt": "Ainsley Davis",
        "height": 1536
    },
    {
        "src": "./album-pictures/2.jpg",
        "width": 852,
        "alt": "Ainsley Davis",
        "height": 727
    },
    {
        "src": "./album-pictures/3.jpg",
        "width": 5337,
        "alt": "Ainsley Davis",
        "height": 4975
    },
    {
        "src": "./album-pictures/4.jpg",
        "width": 1017,
        "alt": "Ainsley Davis",
        "height": 673
    },
    {
        "src": "./album-pictures/5.jpg",
        "width": 1800,
        "alt": "Ainsley Davis",
        "height": 1200
    },
    {
        "src": "./album-pictures/6.jpg",
        "width": 1170,
        "alt": "Ainsley Davis",
        "height": 1149
    },
    {
        "src": "./album-pictures/7.jpg",
        "width": 968,
        "alt": "Ainsley Davis",
        "height": 754
    },
    {
        "src": "./album-pictures/8.jpg",
        "width": 1370,
        "alt": "Ainsley Davis",
        "height": 2055
    },
    {
        "src": "./album-pictures/9.jpg",
        "width": 3604,
        "alt": "Ainsley Davis",
        "height": 5406
    },
    {
        "src": "./album-pictures/10.jpg",
        "width": 1170,
        "alt": "Ainsley Davis",
        "height": 886
    },
    {
        "src": "./album-pictures/11.jpg",
        "width": 2560,
        "alt": "Ainsley Davis",
        "height": 3840
    },
    {
        "src": "./album-pictures/12.jpg",
        "width": 1170,
        "alt": "Ainsley Davis",
        "height": 1309
    },
    {
        "src": "./album-pictures/13.jpg",
        "width": 1170,
        "alt": "Ainsley Davis",
        "height": 1178
    },
    {
        "src": "./album-pictures/14.jpg",
        "width": 1170,
        "alt": "Ainsley Davis",
        "height": 913
    },
    {
        "src": "./album-pictures/15.jpg",
        "width": 1170,
        "alt": "Ainsley Davis",
        "height": 883
    },
    {
        "src": "./album-pictures/16.jpg",
        "width": 7027,
        "alt": "Ainsley Davis",
        "height": 4687
    },
    {
        "src": "./album-pictures/17.jpg",
        "width": 800,
        "alt": "Ainsley Davis",
        "height": 1200
    },
    {
        "src": "./album-pictures/18.jpg",
        "width": 3024,
        "alt": "Ainsley Davis",
        "height": 4032
    },
    {
        "src": "./album-pictures/19.jpg",
        "width": 3290,
        "alt": "Ainsley Davis",
        "height": 3128
    },

    {
        "src": "./album-pictures/20.jpg",
        "width": 1200,
        "alt": "Ainsley Davis",
        "height": 800
    },
    {
        "src": "./album-pictures/21.jpg",
        "width": 1170,
        "alt": "Ainsley Davis",
        "height": 1706
    },
    {
        "src": "./album-pictures/22.jpg",
        "width": 4817,
        "alt": "Ainsley Davis",
        "height": 3441
    },
    {
        "src": "./album-pictures/23.jpg",
        "width": 3301,
        "alt": "Ainsley Davis",
        "height": 2923
    },
    {
        "src": "./album-pictures/24.jpg",
        "width": 5358,
        "alt": "Ainsley Davis",
        "height": 3827
    },
    {
        "src": "./album-pictures/25.jpg",
        "width": 1198,
        "alt": "Ainsley Davis",
        "height": 1800
    },
    {
        "src": "./album-pictures/26.jpg",
        "width": 1440,
        "alt": "Ainsley Davis",
        "height": 960
    },
    {
        "src": "./album-pictures/27.jpg",
        "width": 1170,
        "alt": "Ainsley Davis",
        "height": 1395
    },
    {
        "src": "./album-pictures/28.jpg",
        "width": 1200,
        "alt": "Ainsley Davis",
        "height": 800
    },
    {
        "src": "./album-pictures/29.jpg",
        "width": 1440,
        "alt": "Ainsley Davis",
        "height": 1595
    },

    {
        "src": "./album-pictures/30.jpg",
        "width": 7953,
        "alt": "Ainsley Davis",
        "height": 5302
    },
    {
        "src": "./album-pictures/31.jpg",
        "width": 1440,
        "alt": "Ainsley Davis",
        "height": 1800
    },
    {
        "src": "./album-pictures/32.jpg",
        "width": 1170,
        "alt": "Ainsley Davis",
        "height": 848
    },
    {
        "src": "./album-pictures/33.jpg",
        "width": 1042,
        "alt": "Ainsley Davis",
        "height": 814
    },
    {
        "src": "./album-pictures/34.jpg",
        "width": 1200,
        "alt": "Ainsley Davis",
        "height": 1498
    },
    {
        "src": "./album-pictures/35.jpg",
        "width": 3725,
        "alt": "Ainsley Davis",
        "height": 3745
    },
    {
        "src": "./album-pictures/36.jpg",
        "width": 5792,
        "alt": "Ainsley Davis",
        "height": 3863
    },
    {
        "src": "./album-pictures/37.jpg",
        "width": 1536,
        "alt": "Ainsley Davis",
        "height": 2304
    },
    {
        "src": "./album-pictures/38.jpg",
        "width": 2304,
        "alt": "Ainsley Davis",
        "height": 1536
    },
    {
        "src": "./album-pictures/39.jpg",
        "width": 1988,
        "alt": "Ainsley Davis",
        "height": 1459
    },

    {
        "src": "./album-pictures/40.jpg",
        "width": 5275,
        "alt": "Ainsley Davis",
        "height": 3600
    },
    {
        "src": "./album-pictures/41.jpg",
        "width": 4122,
        "alt": "Ainsley Davis",
        "height": 2944
    },
    {
        "src": "./album-pictures/42.jpg",
        "width": 1712,
        "alt": "Ainsley Davis",
        "height": 1536
    },
    {
        "src": "./album-pictures/43.jpg",
        "width": 1170,
        "alt": "Ainsley Davis",
        "height": 1003
    },
    {
        "src": "./album-pictures/44.jpg",
        "width": 1170,
        "alt": "Ainsley Davis",
        "height": 814
    },
    {
        "src": "./album-pictures/45.jpg",
        "width": 1170,
        "alt": "Ainsley Davis",
        "height": 874
    },
    {
        "src": "./album-pictures/46.jpg",
        "width": 1170,
        "alt": "Ainsley Davis",
        "height": 861
    },
    {
        "src": "./album-pictures/47.jpg",
        "width": 4976,
        "alt": "Ainsley Davis",
        "height": 3554
    },
    {
        "src": "./album-pictures/48.jpg",
        "width": 4354,
        "alt": "Ainsley Davis",
        "height": 3018
    },
    {
        "src": "./album-pictures/49.jpg",
        "width": 1169,
        "alt": "Ainsley Davis",
        "height": 1231
    },

    {
        "src": "./album-pictures/50.jpg",
        "width": 1096,
        "alt": "Ainsley Davis",
        "height": 788
    },
    {
        "src": "./album-pictures/51.jpg",
        "width": 1170,
        "alt": "Ainsley Davis",
        "height": 1106
    },
    {
        "src": "./album-pictures/52.jpg",
        "width": 3643,
        "alt": "Ainsley Davis",
        "height": 5464
    }
];

const Album = () => {
    const [photos, setPhotos] = React.useState([]);
    const [isLoading, setIsLoading] = React.useState(true);

    React.useEffect(()=>{
        setPhotos(photos1)
        document.getElementsByTagName('title')[0].innerHTML='Ainsley Davis 2026 - Album'
        setIsLoading(false)
        console.log(';;')
    },[])
    return (
        <div className="floating-container">
            <h1 className="album-title">Photo Album</h1>
            {!isLoading && <RowsPhotoAlbum layout="rows" photos={photos}/>}
        </div>
    );
};

export default Album;
